import Tabs from '../tabs';
import { useSelector } from "react-redux";
import CircularLoader from "../../../../components/loaders/circularLoader";
import { Box, Card, CardContent, Grid, Alert, Typography, useMediaQuery, TextField, InputAdornment } from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import { useState } from 'react';


export default function CategoryList() {
  const isMobile = useMediaQuery("(max-width:600px)");
  const { getCategories = [], status = '', error = '' } = useSelector((state) => (state.fileCategories || {}));

  const [search, setSearch] = useState("");
  // 🌈 Multiple gradient colors (cycled per card)
  const colors = [
    "linear-gradient(135deg, #667eea 0%, #764ba2 100%)", // blue-purple
    "linear-gradient(135deg, #ff758c 0%, #ff7eb3 100%)", // pink-red
    "linear-gradient(135deg, #43cea2 0%, #185a9d 100%)",  // green-teal
    "linear-gradient(135deg, #f7971e 0%, #ffd200 100%)",// orange-yellow
    "linear-gradient(135deg, #15d8e6ff 0%, #5b86e5 100%)", // cyan-blue
    "linear-gradient(135deg, #fa709a 0%, #fee140 100%)",// coral-yellow
    "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)", // purple-red
    "linear-gradient(135deg, #30cfd0 0%, #330867 100%)",// teal-indigo
    "linear-gradient(135deg, #fa383fff 0%, #e712a4ff 100%)",  // soft pink
    "linear-gradient(135deg, #50e3eeff 0%, #2c7be9ff 100%)", // aqua-blue
    "linear-gradient(135deg, #691350ff 0%, #5b8ce0ff 100%)", // pink-lavender
    "linear-gradient(135deg, #5fe26cff 0%, #8de1f8ff 100%)", // mint-blue
    "linear-gradient(135deg, #f15d18ff 0%, #5b91e9ff 100%)", // subtle gray-blue
    "linear-gradient(135deg, #df8e1cff 0%, #491604ff 100%)",// peach-cream
  ];

  return (
    <div>
      <Tabs />

      <Box>
        {/* Loader */}
        {status === "loading" && (
          <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
            <CircularLoader color="success" />
          </Box>
        )}

        {/* Success */}
        {status === "succeeded" && (
          <>

            <Grid spacing={1} container mt={2}>
              <Grid item size={{ xs: 12, md: 4 }}>
                <TextField
                  size="small"
                  placeholder="Search Category"
                  fullWidth
                  value={search}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (!value.startsWith(" ")) {
                      setSearch(value)
                    }
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      bgcolor: "#f5f5f5",
                      "&.Mui-focused": {
                        bgcolor: "#fff",
                        boxShadow: "0 0 5px rgba(0,0,0,0.1)",
                      },
                    },
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon color="action" />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
            </Grid>


            {Array.isArray(getCategories) && getCategories.filter((item) => item.category_name.toLowerCase().includes(search.toLowerCase())).length !== 0 ? (
              <Grid container spacing={2} mt={2} justifyContent={isMobile ? "center" : "start"}>
                {getCategories.filter((item) => item.category_name.toLowerCase().includes(search.toLowerCase())).map((item, index) => (
                  <Grid item key={index}>
                    <Card
                      sx={{
                        borderRadius: 3,
                        width: 220,
                        height: 80,
                        background: colors[index % colors.length],
                        color: "white",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        position: "relative",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                        transition: "transform 0.2s ease, box-shadow 0.2s ease",
                        "&:hover": {
                          transform: "translateY(-4px)",
                          boxShadow: "0 8px 16px rgba(0,0,0,0.25)",
                        },
                      }}
                    >
                      <CardContent
                        sx={{
                          textAlign: "center",
                          width: "100%",
                          height: "100%",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          p: 2,
                        }}
                      >
                        <Typography
                          variant="body2"
                          sx={{
                            position: "absolute",
                            top: 10,
                            left: 14,
                            opacity: 0.9,
                            fontWeight: 600,
                            fontSize: "0.75rem",
                            color: "#f0f0f0",
                          }}
                        >
                          #{index + 1}
                        </Typography>

                        <Typography
                          variant="subtitle1"
                          sx={{
                            fontWeight: 500,
                            fontSize: "0.9rem",
                            color: "#ffffff",
                            wordBreak: "break-word",
                          }}
                        >
                          {item?.category_name || ''}
                        </Typography>
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            ) : (
              <Box sx={{ textAlign: "center", mt: 3 }}>No Data Found</Box>
            )}
          </>
        )}

        {/* Error */}
        {status === "failed" && (
          <Box mt={3}>
            <Alert severity="error">{error}</Alert>
          </Box>
        )}
      </Box>
    </div>
  );
}
